import { render, staticRenderFns } from "./CarTemplateAssign.vue?vue&type=template&id=509cb719&scoped=true"
import script from "./CarTemplateAssign.vue?vue&type=script&lang=js"
export * from "./CarTemplateAssign.vue?vue&type=script&lang=js"
import style0 from "./CarTemplateAssign.vue?vue&type=style&index=0&id=509cb719&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509cb719",
  null
  
)

export default component.exports